/**
 * Logo — mesma imagem oficial usada no backoffice (`Dashboard.tsx`'s
 * `TopBrasilLogo`) e no login (`LoginNew.tsx`), para o painel do cooperado
 * não divergir visualmente do resto do sistema. O handoff de design propõe
 * uma recriação em 3 pílulas CSS, mas a consistência entre telas do mesmo
 * produto pesa mais que a fidelidade a esse detalhe do protótipo.
 */
export function CooperadoLogo() {
  return (
    <div className="co-marca">
      <img src="/assets/logo-cooper.png" alt="Coopertransmig" />
      <span className="co-marca-rotulo">FRETAMENTO</span>
    </div>
  );
}
